import React from 'react';
import StorySlides from '../StorySlides';

const OurStory = () => {
  return <StorySlides />;
};

export default OurStory;